export default __webpack_public_path__ + "static/61-2a7e31c710ab3d6989c9586517238eee.gif";